//client\src\store.js
import { defineStore } from "pinia";

export const useSidebarStore = defineStore('sidebar', {
  state: () => ({
    isCollapsed: false, // Default to expanded
    isHovered: false
  }),
  actions: {
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed;
    },
    collapseSidebar() {
      this.isCollapsed = true;
    },
    expandSidebar() {
      this.isCollapsed = false;
    },
  }
});

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
  }),
  actions: {
    setUser(user) {
      this.user = user;
    },
    login() {

      const heroImage = window.selectedHeroImage || 'na'
      if (window.gtag) {
        window.gtag('event', 'login_click', {
          hero_image: heroImage
        });
      }

      const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
      window.location.href = `${API_BASE_URL}/login`;
    },
    logout() {
      const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
      window.location.href = `${API_BASE_URL}/logout`;
    },
  },
});

export const useModalStore = defineStore("modal", {
  state : () => ({
    isNewAquariumModalVisible: false,
    newAquariumModalMode: 'user',
    newAquariumModalVerb: 'create',
    prefilledAquariumData: {},
    isNewDataLogModalVisible: false,
    newDataLogModalMode: 'user',
    newDataLogModalVerb: 'create',
    prefilledDataLogData: {},
    isNewUserModalVisible: false,
    newUserModalVerb: 'create',
    prefilledUserData: {},
  }),
  actions: {
    openNewAquariumModal({ mode = 'user', verb = 'create', prefilledData = {} } = {}) {
      this.newAquariumModalMode = mode;
      this.newAquariumModalVerb = verb;
      this.prefilledAquariumData = prefilledData;
      this.isNewAquariumModalVisible = true;
    },
    closeNewAquariumModal() {
      this.isNewAquariumModalVisible = false;
    },
    
    openDataLogModal({ mode = 'user', verb = 'create', prefilledData = {} } = {}) {
      this.newDataLogModalMode = mode;
      this.newDataLogModalVerb = verb;
      this.prefilledDataLogData = prefilledData;
      this.isNewDataLogModalVisible = true;
    },
    closeNewDataLogModal() {
      this.isNewDataLogModalVisible = false;
    },
    
    openNewUserModal({ verb = 'create', prefilledData = {} } = {}) {
      this.newUserModalVerb = verb;
      this.prefilledUserData = prefilledData;
      this.isNewUserModalVisible = true;
    },
    closeNewUserModal() {
      this.isNewUserModalVisible = false;
    },

    closeAllModals() {
      this.isNewAquariumModalVisible = false;
      this.isNewDataLogModalVisible = false;
      this.isNewUserModalVisible = false;
    },
  }
});

export const usePopupStore = defineStore("error", {
  state: () => ({
    messageTitle: null,
    messageText: null,
    showMessage: false,
    messageType: 'error'
  }),
  actions: {
    setMessage(title, message, color = 'error') {
      this.messageTitle = title;
      this.messageText = message;
      this.showMessage = true;
      this.messageType = color;
    },
    clearMessage() {
      this.messageTitle = null;
      this.messageText = null;
      this.showMessage = false;
      this.messageType = 'error';
    }
  },
});
